import { BooleanCell } from "./BooleanCell";
import { DefaultCell } from "./DefaultCell";
import { IndicateurCell } from "./IndicateurCell";
import { StatutCell } from "./StatutCell";
import { UccCell } from "./UccCell";
import { UccIndicateurCell } from "./UccIndicateurCell";
import { ZeroEmptyString } from "./ZeroEmptyString";

export const customCells = {
  BooleanCell,
  ZeroEmptyString,
  StatutCell,
  IndicateurCell,
  DefaultCell,
  UccCell,
  UccIndicateurCell,
};

export type CustomCellType = keyof typeof customCells;

export const customCellFeed = (type: string) => {
  switch (type as CustomCellType) {
    case "BooleanCell":
      return BooleanCell;
    case "IndicateurCell":
      return IndicateurCell;
    case "UccIndicateurCell":
      return UccIndicateurCell;
    case "StatutCell":
      return StatutCell;
    case "ZeroEmptyString":
      return ZeroEmptyString;
    case "UccCell":
      return UccCell;
    case "DefaultCell":
    default:
      return DefaultCell;
  }
};
